import { useEffect } from "react";

/**
 * Swap the PWA identity documents (manifest + Apple meta) at runtime so that
 * `/admin` advertises a *separately installable* PWA distinct from the guest
 * app on the same origin.
 *
 * Usage:
 *   <PwaManifest scope="guest" />   → inside guest Layout
 *   <PwaManifest scope="admin" />   → inside Admin page
 *
 * The component simply mutates <head>; there is no visible output.
 */
const PROFILES = {
  guest: {
    manifest: "/manifest.webmanifest",
    appleIcon: "/icons/apple-touch-icon.png",
    appleTitle: "Eli & Mag",
    themeColor: "#181614",
  },
  admin: {
    manifest: "/admin-manifest.webmanifest",
    appleIcon: "/icons/admin-apple-touch-icon.png",
    appleTitle: "E&M Admin",
    themeColor: "#181614",
  },
};

function upsertLink(rel, href, extraAttrs = {}) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  Object.entries(extraAttrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

function upsertMeta(name, content) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return el;
}

export const PwaManifest = ({ scope = "guest" }) => {
  useEffect(() => {
    const p = PROFILES[scope] || PROFILES.guest;
    upsertLink("manifest", p.manifest);
    upsertLink("apple-touch-icon", p.appleIcon);
    upsertMeta("apple-mobile-web-app-title", p.appleTitle);
    upsertMeta("theme-color", p.themeColor);
  }, [scope]);
  return null;
};

export default PwaManifest;
